
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';
import Tag from 'primevue/tag';
import Button from 'primevue/button';

import { ref, watch, onMounted } from 'vue';
import PopupWalletNavbar from '../components/navbar/PopupWalletNavbar.vue';
import { Transaction } from '../types/transaction';
import { depositWithdraw } from '../apis/deposit_withdraw';
import { useAuthStore } from '../stores/auth';
import { storeToRefs } from 'pinia';
import { formatCurrency } from '../utils/currency';
import { PlayerTransactionRecord, PlayerTransactionResult } from '../types/deposit_withdraw';
import { main_wallet } from '../apis/main_wallet';
import Card from 'primevue/card';
import { useToast } from 'primevue/usetoast';

export default {
	name: 'WalletTransaction',
	methods: { formatCurrency },
	components: {
		PopupWalletNavbar,
		Tabs,
		TabPanels,
		TabPanel,
		TabList,
		Tab,
		DataTable,
		Column,
		Paginator,
		Tag,
		Button,
		Card,
	},
	props: {
		tabs: {
			type: String,
			default: 'deposit',
		},
	},
	setup(props) {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const toast = useToast();

		const tabs = ref<string>(props.tabs);

		const first = ref(0);
		const rows = ref(10);

		const tableLoading = ref(false);
		const btnRejectLoading = ref(false);

		const transaction = ref<PlayerTransactionResult>({
			records: [],
			totalRecord: 0,
		});

		const handleRejectTrans = async (id: string) => {
			btnRejectLoading.value = true;
			try {
				const payload = {
					rejectTransId: id,
				}

				const resp = await main_wallet.receiveRejectTrans(payload);

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message)

				toast.add({ severity: 'success', summary: resp.message, life: 3000 });

				await fetchTransaction()

				await auth.fetchData();
				auth.hydrate();
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				btnRejectLoading.value = false;
			}
		}

		const fetchTransaction = async () => {
			tableLoading.value = true;
			try {
				const page = Math.floor(first.value / rows.value) + 1;
				const transactionType = tabs.value === 'deposit' ? 'DEPOSIT' : 'WITHDRAW';

				const resp = await depositWithdraw.getPlayerTransaction({
					transactionType,
					page,
					limit: rows.value,
				});

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				transaction.value = resp.result as PlayerTransactionResult;
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				tableLoading.value = false;
			}
		};

		watch([tabs, first], () => {
			fetchTransaction();
			transaction.value = {
				records: [],
				totalRecord: 0,
			}
		}, { immediate: true });

		return {
			tabs,
			first,
			rows,
			transaction,
			tableLoading,
			btnRejectLoading,
			handleRejectTrans,
		};
	},
};
